export default {"src":"/_next/static/media/English.cc07fcc4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};